// this is used to convert the string properties on incoming objects to uppercase since the mobile app is uppercase only

export class ObjectUtils {
    // eslint-disable-next-line
    static convertToUppercase(object) {
        if (object == null) return object;

        if (Array.isArray(object)) {
            return this.uppercaseArrayContents(object);
        }

        return this.uppercaseObjectProperties(object);
    }

    // eslint-disable-next-line
    static uppercaseArrayContents(theArray) {
        let result = [];

        for (let i = 0; i < theArray.length; i++) {
            result.push(this.convertToUppercase(theArray[i]));
        }

        return result;
    }

    // eslint-disable-next-line
    static uppercaseObjectProperties(object) {
        let result = {};
        for (const [fieldName, fieldValue] of Object.entries(object)) {
            if (typeof fieldValue === "object" && fieldValue) {
                // if the field is another object, recurse through it
                result = { ...result, [fieldName]: this.convertToUppercase(fieldValue) };
            } else if (typeof fieldValue === "string" && fieldName !== "__typename" && fieldName !== "signature") {
                // convert strings to uppercase except for the __typename attribute
                result = { ...result, [fieldName]: fieldValue.toLocaleUpperCase() };
            } else {
                // don't touch anything else
                result = { ...result, [fieldName]: fieldValue };
            }
        }

        return result;
    }
}
